module.exports = "/images/vendor/flag-icon-css/flags/1x1/gq.svg?80b56bda22009d765f2e84d9302b0229";